// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  width: 50%;
  justify-content: center;
  align-items: center;
}

mat-card {
  width: 500px;
  padding: 24px;
}

.welcome-section {
  text-align: center;
  margin-bottom: 24px;
}
.welcome-section h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 500;
}
.welcome-section .subtitle {
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}

.auto-config {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}
.auto-config .config-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.auto-config .config-item .label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.auto-config .config-item .value {
  font-family: monospace;
  font-size: 14px;
  font-weight: 500;
}

.primary-action {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.primary-action .start-trial-btn {
  padding: 8px 48px;
  font-size: 16px;
}

.advanced-panel {
  margin-top: 16px;
  box-shadow: none !important;
  background: transparent;
}
.advanced-panel ::ng-deep .mat-expansion-panel-body {
  padding: 16px 0 0 0;
}

.column {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: row;
}

.nwi-select {
  margin-left: 10px;
}

.progress-container {
  margin-bottom: 10px;
}

.progress {
  padding-left: 5px;
}

.complete {
  color: green;
}

.icon {
  padding: 12px 6px 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/init/init.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,SAAA;EACA,yBAAA;EACA,eAAA;AAAJ;;AAIA;EACE,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,yBAAA;EACA,eAAA;AADN;AAII;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AAFN;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAME;EACE,iBAAA;EACA,eAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,2BAAA;EACA,uBAAA;AALF;AAOE;EACE,mBAAA;AALJ;;AASA;EACE,aAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,qBAAA;AANF","sourcesContent":[".container {\n  margin-top: 60px;\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n  width: 50%;\n  justify-content: center;\n  align-items: center;\n}\n\nmat-card {\n  width: 500px;\n  padding: 24px;\n}\n\n.welcome-section {\n  text-align: center;\n  margin-bottom: 24px;\n\n  h2 {\n    margin: 0 0 8px 0;\n    font-size: 24px;\n    font-weight: 500;\n  }\n\n  .subtitle {\n    margin: 0;\n    color: rgba(0, 0, 0, 0.6);\n    font-size: 14px;\n  }\n}\n\n.auto-config {\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n\n  .config-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .label {\n      color: rgba(0, 0, 0, 0.6);\n      font-size: 14px;\n    }\n\n    .value {\n      font-family: monospace;\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n}\n\n.primary-action {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n\n  .start-trial-btn {\n    padding: 8px 48px;\n    font-size: 16px;\n  }\n}\n\n.advanced-panel {\n  margin-top: 16px;\n  box-shadow: none !important;\n  background: transparent;\n\n  ::ng-deep .mat-expansion-panel-body {\n    padding: 16px 0 0 0;\n  }\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n}\n\n.nwi-select {\n  margin-left: 10px;\n}\n\n.progress-container {\n  margin-bottom: 10px;\n}\n\n.progress {\n  padding-left: 5px;\n}\n\n.complete {\n  color: green;\n}\n\n.icon {\n  padding: 12px 6px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
